<ng-container *transloco="let t">
  <ld-base-modal [title]="t('modalsPaymentReviewTitle')" (closeModal)="onClose()">
    <div modal-content>
      <div id="payment-review-total" class="mb-6 text-center">
        <p class="font-dm text-lg text-ld-neutral-500">{{ t('paymentReviewTitle') }}</p>
        <p class="font-dm text-4xl font-bold text-ld-neutral">
          {{ paymentData().totalAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
        </p>
        <p class="font-dm text-sm text-ld-neutral-500">{{ t('paymentReviewTotalAmount') }}</p>
      </div>

      <div id="payment-review-details" class="mb-6 rounded-xl bg-ld-neutral-50 p-4">
        <div class="grid grid-cols-2 gap-4">
          <div id="payment-review-date">
            <p class="font-dm text-sm font-semibold text-ld-neutral">{{ t('commonFieldsPaymentDate') }}</p>
            <p class="font-dm text-sm text-ld-neutral-500">{{ formatDate(paymentData().paymentDate) }}</p>
          </div>
          <div id="payment-review-due-date">
            <p class="font-dm text-sm font-semibold text-ld-neutral">{{ t('commonDueDate') }}</p>
            <p class="font-dm text-sm text-ld-neutral-500">{{ formatDate(paymentData().dueDate) }}</p>
          </div>
          <div id="payment-review-account" class="col-span-2">
            <p class="font-dm text-sm font-semibold text-ld-neutral">{{ t('paymentReviewPayingFrom') }}</p>
            <p class="font-dm text-sm text-ld-neutral-500">
              {{ paymentData().bankAccountDisplay }} - *******{{ paymentData().lastFourDigits }}
            </p>
          </div>
        </div>

        @if (paymentData().breakdown) {
          <div id="payment-review-breakdown" class="mt-4 border-t border-ld-border pt-4">
            <p class="font-dm text-sm font-semibold text-ld-neutral mb-2">{{ t('paymentBreakdownTitle') }}</p>
            @if (paymentData().breakdown?.principalAndInterest) {
              <div class="flex justify-between text-sm">
                <span class="font-dm text-ld-neutral-500">{{ t('commonPrincipalAndInterest') }}</span>
                <span class="font-dm text-ld-neutral">
                  {{ paymentData().breakdown?.principalAndInterest | currency: 'USD' : 'symbol' : '1.2-2' }}
                </span>
              </div>
            }
            @if (paymentData().breakdown?.taxesAndInsurance) {
              <div class="flex justify-between text-sm">
                <span class="font-dm text-ld-neutral-500">{{ t('modalsPaymentReviewTaxesAndInsurance') }}</span>
                <span class="font-dm text-ld-neutral">
                  {{ paymentData().breakdown?.taxesAndInsurance | currency: 'USD' : 'symbol' : '1.2-2' }}
                </span>
              </div>
            }
            @if (paymentData().breakdown?.additionalPrincipal) {
              <div class="flex justify-between text-sm">
                <span class="font-dm text-ld-neutral-500">{{ t('commonAutopayAdditionalPrincipal') }}</span>
                <span class="font-dm text-ld-neutral">
                  {{ paymentData().breakdown?.additionalPrincipal | currency: 'USD' : 'symbol' : '1.2-2' }}
                </span>
              </div>
            }
            @if (paymentData().breakdown?.additionalEscrow) {
              <div class="flex justify-between text-sm">
                <span class="font-dm text-ld-neutral-500">{{ t('paymentAmountAdditionalEscrow') }}</span>
                <span class="font-dm text-ld-neutral">
                  {{ paymentData().breakdown?.additionalEscrow | currency: 'USD' : 'symbol' : '1.2-2' }}
                </span>
              </div>
            }
            @if (paymentData().breakdown?.fees) {
              <div class="flex justify-between text-sm">
                <span class="font-dm text-ld-neutral-500">{{ t('commonFieldsFees') }}</span>
                <span class="font-dm text-ld-neutral">
                  {{ paymentData().breakdown?.fees | currency: 'USD' : 'symbol' : '1.2-2' }}
                </span>
              </div>
            }
          </div>
        }
      </div>

      <div id="payment-review-terms" class="mb-6 text-xs text-ld-neutral-500">
        <p class="mb-2">{{ t('modalsPaymentReviewConsentAuth') }}</p>
        <p
          class="mb-2"
          [innerHTML]="
            t('modalsPaymentReviewConsentAccountInfo', {
              name: paymentData().accountHolderName,
              date: formatDate(paymentData().paymentDate),
              lastFour: paymentData().lastFourDigits,
              amount: formattedTotalAmount(),
            })
          "
        ></p>
        <p
          [innerHTML]="
            t('modalsPaymentReviewConsentContact', {
              tel: customerServiceTel(),
              phone: customerServicePhone(),
            })
          "
          (click)="onTelClick($event)"
          (keydown.enter)="onTelClick($event)"
          tabindex="0"
        ></p>
      </div>
    </div>
    <div modal-footer>
      <button
        id="payment-review-edit-btn"
        type="button"
        class="btn-outline-ld-purple"
        (click)="onEdit()"
        [disabled]="isLoading()"
      >
        {{ t('paymentReviewEditPayment') }}
      </button>
      <button
        id="payment-review-confirm-btn"
        type="button"
        class="btn-primary-ld-purple px-6 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="onConfirm()"
        [disabled]="isLoading()"
      >
        @if (isLoading()) {
          <span class="flex items-center gap-2">
            <mat-spinner diameter="16"></mat-spinner>
            {{ t('commonMessagesProcessing') }}
          </span>
        } @else {
          {{ t('paymentReviewConfirmPayment') }}
        }
      </button>
    </div>
  </ld-base-modal>
</ng-container>
